"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mobx = require("mobx");

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _class, _descriptor, _descriptor2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var TableRowModel = (_class = /*#__PURE__*/function () {
  function TableRowModel(data) {
    _classCallCheck(this, TableRowModel);

    _initializerDefineProperty(this, "rowData", _descriptor, this);

    _initializerDefineProperty(this, "toggledColumns", _descriptor2, this);

    this.rowData = _mobx.observable.map(data);
    this.toggledColumns = _mobx.observable.map({});
  }

  _createClass(TableRowModel, [{
    key: "data",
    get: function get() {
      if ((0, _isEmpty.default)(this.toggledColumns)) {
        return this.rowData;
      } // patching in old functionality to expose toggled status


      var data = new Map(this.rowData);
      (0, _forEach.default)((0, _mobx.toJS)(this.toggledColumns), function (isToggled, columnName) {
        if (isToggled) {
          data.set("show-".concat(columnName), true);
        }
      });
      return data;
    }
  }, {
    key: "toggleColumn",
    value: function toggleColumn(columnName, loadDataFunction) {
      var _this = this;

      if (!this.rowData.get(columnName) && (0, _isFunction.default)(loadDataFunction)) {
        loadDataFunction(function () {
          _this.toggledColumns.set(columnName, true);
        });
      } else {
        this.toggledColumns.set(columnName, !this.toggledColumns.get(columnName));
      }
    }
  }]);

  return TableRowModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "rowData", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "toggledColumns", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "data", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "data"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleColumn", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleColumn"), _class.prototype)), _class);
var _default = TableRowModel;
exports.default = _default;